/** @jsx jsx */
import { memo } from 'react';
import { jsx } from '@emotion/react';
import Box from '@atlaskit/primitives/box';
import DateComponent from './date';
import WeekdayGrid from './week-day-grid';
const WeekDays = /*#__PURE__*/memo(function WeekDays({
  weeks,
  handleClickDay,
  mode,
  monthsLong,
  shouldSetFocus,
  tabIndex,
  testId
}) {
  return jsx(Box, {
    role: "rowgroup",
    testId: testId && `${testId}--month`
  }, weeks.map((week, i) => jsx(WeekdayGrid, {
    key: i,
    testId: testId && `${testId}--week`
  }, week.values.map(weekDay => jsx(DateComponent, {
    key: `${week.id}-${weekDay.id}`,
    isDisabled: weekDay.isDisabled,
    isFocused: weekDay.isFocused,
    isToday: weekDay.isToday,
    dayLong: weekDay.weekDayName,
    month: weekDay.month,
    monthLong: monthsLong[weekDay.month - 1],
    onClick: handleClickDay,
    isPreviouslySelected: weekDay.isPreviouslySelected,
    isSelected: weekDay.isSelected,
    isSibling: weekDay.isSiblingMonth,
    year: weekDay.year,
    mode: mode,
    shouldSetFocus: shouldSetFocus,
    tabIndex: tabIndex,
    testId: testId
  }, weekDay.day)))));
});
WeekDays.displayName = 'WeekDays';

// eslint-disable-next-line @repo/internal/react/require-jsdoc
export default WeekDays;